/*
  Nordicsell TEST-TEMA 2026-09-23: synligt sokfalt i headern.

  Zalando och Shein har ett riktigt sokfalt i headern, inte bara en ikon.
  Det har skriptet lagger en knapp som ser ut som ett sokfalt i headerns
  tomma mittkolumn (grid-area "spacer" fran snippets/ns-topbar.liquid).
  Klick oppnar SAMMA sokpanel som forstoringsglaset (snippets/ns-sokruta),
  genom att klicka pa ikonen. Ingen egen sokning, inget nytt API.
  Pa skarmar under 1024 px doljs faltet med CSS och ikonen finns kvar.
  Utseendet styrs i assets/ns-design.css, avsnitt 3.
*/
(function () {
  // LEO UTAN CJ 2026-10-23 (punkt 167): exemplen ar utbytta - klanningar och graverade halsband (CJ) finns inte langre.
  // Forut: 'Sök bland klänningar, hudvård, presenter …', 'Sök t.ex. maxiklänning', 'Sök t.ex. doftljus', 'Sök t.ex. graverat halsband'.
  var PLACEHOLDERS = ['Sök bland väskor, smycken, hudvård …', 'Sök t.ex. axelväska', 'Sök t.ex. doftljus', 'Sök t.ex. halsband'];

  function build() {
    var top = document.querySelector('.header__top');
    if (!top || top.querySelector('.ns-sokbar')) return;
    var icon = top.querySelector('.header__search .search__field-icon') || top.querySelector('.header__search button');
    if (!icon) return;

    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'ns-sokbar';
    bar.setAttribute('aria-label', 'Sök i butiken');
    bar.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span class="ns-sokbar__txt"></span>';
    var txt = bar.querySelector('.ns-sokbar__txt');
    txt.textContent = PLACEHOLDERS[0];
    bar.addEventListener('click', function (e) {
      e.preventDefault();
      var i = document.querySelector('.header__top .header__search .search__field-icon') || document.querySelector('.header__top .header__search button');
      if (i) i.click();
    });
    // Omgang 8 (Boozt): soket ar en ikon bland ikonerna till hoger
    // (sok, konto, favoriter, varukorg). Finns inte ikongruppen hamnar
    // knappen som forut sist i .header__top.
    var hoger = top.querySelector('.header__icons--right .header__buttons');
    if (hoger) { hoger.insertBefore(bar, hoger.firstChild); } else { top.appendChild(bar); }

    var n = 0;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () {
        n = (n + 1) % PLACEHOLDERS.length;
        txt.textContent = PLACEHOLDERS[n];
      }, 3500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('load', build);

  /*
    Omgang 4: varukorgslådan (snippets/ns-varukorgslada) far en knapp
    DIREKT TILL KASSAN overst, som Boozt och Zalando. Den gamla knappen
    till varukorgssidan finns kvar under, som "Visa varukorg".
    Lådan ritar om botten varje gang korgen andras, darfor lyssnar vi
    efter nya knappar. Lådans egen fil rors inte.
  */
  function kassaILadan() {
    var k = document.querySelector('.nsvk__botten a.nsvk__kassa:not([data-ns-klar])');
    if (!k) return;
    k.setAttribute('data-ns-klar', '1');
    var delar = k.textContent.split('·');
    var summa = delar.length > 1 ? delar[1].trim() : '';
    /* Omgang 3m (farg-versionen, kundens onskan): den stora svarta knappen
       overst gar TILL VARUKORGEN och den vita under TILL KASSAN. Forut
       tvart om (svart = kassan, vit = "Visa varukorg"). Den vita
       knappen lanar utseendet fran .ns-visakorg i ns-design.css. */
    var ny = document.createElement('a');
    ny.className = 'nsvk__kassa ns-visakorg ns-kassa-vit';
    ny.setAttribute('data-ns-klar', '1');
    ny.href = '/checkout';
    ny.textContent = 'Till kassan' + (summa ? ' · ' + summa : '');
    k.parentNode.insertBefore(ny, k.nextSibling);
    k.textContent = 'Till varukorgen';
  }
  if (window.MutationObserver) {
    new MutationObserver(kassaILadan).observe(document.documentElement, { childList: true, subtree: true });
  }

  /*
    Omgang 8 (Boozt): toppraden (.nstb) visar ETT budskap i taget med
    pilar till vanster och hoger, som Boozts kampanjrad. Byter sjalv var
    5:e sekund, stannar nar musen ar over raden. Lankarna ar desamma som
    forut - de visas bara en i taget. Utseendet: assets/ns-struktur.css (p).
  */
  function toppradKarusell() {
    /* Omgang 4o (2026-09-26, farg-versionen): Hilton vill ha toppraden som
       TRE FASTA SEKTIONER bredvid varandra (30 dagars retur, Fri frakt over
       470 kr, Just nu: heta deals) i stallet for ett budskap i taget.
       Karusellen startas darfor inte - utseendet satts i assets/ns-bredd.css
       (omgang 4o). ANGRA: ta bort raden "return;" nedan. */
    return;
    var tb = document.querySelector('.nstb');
    if (!tb || tb.getAttribute('data-ns-kar')) return;
    var inner = tb.querySelector('.nstb__inner');
    var lankar = inner ? [].slice.call(inner.querySelectorAll('.nstb-btn')) : [];
    if (!lankar.length) return;
    tb.setAttribute('data-ns-kar', '1');
    tb.classList.add('nstb--kar');
    function pil(riktning, etikett, d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nstb-pil nstb-pil--' + riktning;
      b.setAttribute('aria-label', etikett);
      b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
      return b;
    }
    var fore = pil('fore', 'Föregående', 'M15 18l-6-6 6-6');
    var nasta = pil('nasta', 'Nästa', 'M9 18l6-6-6-6');
    tb.insertBefore(fore, tb.firstChild);
    tb.appendChild(nasta);
    var i = 0;
    function visa(n) {
      i = (n + lankar.length) % lankar.length;
      lankar.forEach(function (l, k) {
        var aktiv = k === i;
        l.classList.toggle('is-aktiv', aktiv);
        l.setAttribute('aria-hidden', aktiv ? 'false' : 'true');
        l.tabIndex = aktiv ? 0 : -1;
      });
    }
    fore.addEventListener('click', function () { visa(i - 1); });
    nasta.addEventListener('click', function () { visa(i + 1); });
    visa(0);
    if (lankar.length > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var paus = false;
      tb.addEventListener('mouseenter', function () { paus = true; });
      tb.addEventListener('mouseleave', function () { paus = false; });
      setInterval(function () { if (!paus) visa(i + 1); }, 5000);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toppradKarusell);
  } else {
    toppradKarusell();
  }
  window.addEventListener('load', toppradKarusell);

  /*
    Omgang 8: fargfiltret (snippets/facets.liquid, <ns-color-group>) i
    VANSTERSPALTEN/filterraden reagerade inte pa klick. Elementets skript
    kopplar knappen i connectedCallback, men for grupper som tolkas EFTER
    att elementet definierats finns knappen inte an da - sa de blev aldrig
    kopplade (bara lådans grupper fungerade). Har tar vi hand om de
    okopplade knapparna med en gemensam klicklyssnare: samma sak som
    originalet gor (bocka i/ur alla nyanser i gruppen och meddela
    formularet). Kopplade knappar (data-ns-bound) lamnas at originalet.
  */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ns-cg-btn') : null;
    if (!btn || btn.dataset.nsBound || btn.disabled) return;
    var grupp = btn.closest('ns-color-group');
    if (!grupp) return;
    var inputs = [].slice.call(grupp.querySelectorAll('.ns-cg-input'));
    if (!inputs.length) return;
    e.preventDefault();
    var nagon = inputs.some(function (i) { return i.checked; });
    inputs.forEach(function (i) { i.checked = !nagon; });
    inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
  });

  /*
    Omgang 8: temats facets.js lagger laddningslaget (btn--loading) med
    100 ms fordrojning men tar bort det direkt nar svaret kommer. Kommer
    svaret snabbare an 100 ms blir laget kvar - antalet produkter doljs
    och en snurra syns. Efter varje omritning tar vi bort det igen.
  */
  document.addEventListener('collection:rerendered', function () {
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('[data-facet-loading].btn--loading'), function (el) {
        el.classList.remove('btn--loading');
      });
    }, 250);
  });
  /*
    Omgang 9 (Boozt): menyladan. Boozts lada tacker hela hojden och har
    overst sok, logga och stang, sedan segmentknapparna (KVINNOR, MAN,
    BARN, SPORT, SKONHET, HEM) och darunder listan. Langst ner kundservice,
    konto och "Skickar till". Har byggs samma sak runt temats egen lada:
    listan, undermenyerna och kontolanken ar temats egna. Segmentknapparna
    oppnar samma undermeny som raden i listan. Landvaljaren (.ns-locale)
    flyttas fran headern ner i ladan. Utseendet: assets/ns-struktur.css (y).
  */
  // LEO UTAN CJ 2026-10-23 (punkt 167): menyn huvudmeny-utan-cj har inte Kvinna, Man och Traning & Halsa.
  // Forut: ['Kvinna', 'Man', 'Barn', 'Träning & Hälsa', 'Skönhet', 'Hem & Inredning'].
  var SEGMENT = ['Fashion', 'Barn', 'Skönhet', 'Hem & Inredning'];
  function svg(d, w) {
    return '<svg width="' + (w || 20) + '" height="' + (w || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  function menyLada() {
    var md = document.querySelector('menu-drawer#MenuDrawer');
    if (!md || md.getAttribute('data-ns-lada')) return;
    var content = md.querySelector('.menu-drawer__content');
    var nav = content ? content.querySelector('nav') : null;
    var knapp = document.querySelector('.header__icons--left .menu-drawer-button');
    if (!content || !nav || !knapp) return;
    md.setAttribute('data-ns-lada', '1');
    md.classList.add('nsml');

    // 1. Topprad: sok - logga - stang
    var topp = document.createElement('div');
    topp.className = 'nsml-topp';
    var sok = document.createElement('button');
    sok.type = 'button';
    sok.className = 'nsml-sok';
    sok.setAttribute('aria-label', 'Sök');
    sok.innerHTML = svg('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>');
    sok.addEventListener('click', function () {
      knapp.click();
      setTimeout(function () {
        var s = document.querySelector('.ns-sokbar');
        if (s && s.offsetParent !== null) { s.click(); return; }
        var i = document.querySelector('.header__top .header__search .search__field-icon') || document.querySelector('.header__top .header__search button');
        if (i) i.click();
      }, 350);
    });
    var logga = document.querySelector('.header__logo a');
    var loggaKopia = logga ? logga.cloneNode(true) : document.createElement('a');
    loggaKopia.className = 'nsml-logga';
    if (!logga) { loggaKopia.href = '/'; loggaKopia.textContent = 'NORDICSELL'; }
    var stang = document.createElement('button');
    stang.type = 'button';
    stang.className = 'nsml-stang';
    stang.setAttribute('aria-label', 'Stäng menyn');
    stang.innerHTML = svg('<path d="M6 6l12 12M18 6 6 18"/>');
    stang.addEventListener('click', function () { knapp.click(); });
    topp.appendChild(sok);
    topp.appendChild(loggaKopia);
    topp.appendChild(stang);
    content.insertBefore(topp, content.firstChild);

    // 2. Segmentknappar
    var rader = [].slice.call(nav.querySelectorAll('.menu-drawer__menus > ul > li.menu-drawer__item'));
    var rad = document.createElement('div');
    rad.className = 'nsml-seg';
    SEGMENT.forEach(function (namn) {
      var li = rader.filter(function (r) {
        var s = r.querySelector(':scope > details > summary');
        return s && s.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === namn.toLowerCase();
      })[0];
      if (!li) return;
      var det = li.querySelector(':scope > details');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nsml-segknapp';
      b.textContent = namn;
      b.addEventListener('click', function () {
        if (det.hasAttribute('open')) return;
        var oppen = nav.querySelector('.menu-drawer__menus > ul > li > details[open]');
        if (oppen && oppen !== det) {
          var tillbaka = oppen.querySelector('.menu-drawer__item-back-link');
          if (tillbaka) { tillbaka.click(); } else { oppen.querySelector('summary').click(); }
          setTimeout(function () { det.querySelector('summary').click(); }, 320);
        } else {
          det.querySelector('summary').click();
        }
      });
      b._det = det;
      rad.appendChild(b);
    });
    if (rad.children.length) {
      content.insertBefore(rad, nav);
      var markera = function () {
        [].forEach.call(rad.children, function (b) { b.classList.toggle('is-aktiv', b._det.hasAttribute('open')); });
      };
      if (window.MutationObserver) new MutationObserver(markera).observe(nav, { attributes: true, subtree: true, attributeFilter: ['open'] });
      markera();
    }

    // 3. Botten: kundservice, konto (temats), skickar till (landvaljaren)
    var fot = md.querySelector('.menu-drawer__footer .grid') || md.querySelector('.menu-drawer__footer');
    if (fot) {
      var ks = document.createElement('a');
      ks.className = 'nsml-rad nsml-kundservice';
      ks.href = '/pages/kontakta-oss';
      ks.innerHTML = svg('<path d="M4 13v-1a8 8 0 0 1 16 0v1"/><rect x="3" y="13" width="4" height="6" rx="1"/><rect x="17" y="13" width="4" height="6" rx="1"/>') + '<span>Kundservice</span>';
      fot.insertBefore(ks, fot.firstChild);
      var land = document.createElement('div');
      land.className = 'nsml-rad nsml-land';
      land.innerHTML = '<span class="nsml-land__txt">Skickar till</span>';
      fot.appendChild(land);
      var flytta = function () {
        var loc = document.querySelector('.ns-locale');
        if (loc && loc.parentNode !== land) land.appendChild(loc);
      };
      flytta();
      window.addEventListener('load', function () { setTimeout(flytta, 300); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', menyLada);
  } else {
    menyLada();
  }
  window.addEventListener('load', menyLada);

  /*
    Omgang 9 (Boozt): pa soksidan (fran 1024 px) star filtren i
    vansterspalten oppna, som hos Boozt. Stanger kunden en grupp far den
    vara stangd, aven nar sidan ritas om efter ett filterval (temat ritar
    da om spalten och alla grupper borjar stangda). Utseendet:
    assets/ns-struktur.css (z).
  */
  var sokStangda = {};
  // Temats filtergrupper ar <details is="accordion-details">. Deras egen
  // oppning animeras och kraver att temats skript ar klart, darfor oppnas
  // de har direkt (utan animation) och temats tillstand (isOpen,
  // aria-expanded) satts sa att nasta klick stanger som vanligt.
  function oppnaGrupp(d) {
    var C = window.customElements && customElements.get('accordion-details');
    d.setAttribute('open', '');
    d.setAttribute('aria-expanded', 'true');
    if (C && d instanceof C) d.isOpen = true;
    d.style.height = '';
    d.style.overflow = '';
  }
  function sokFilterOppna() {
    if (!document.body || !document.body.classList.contains('search-template')) return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches) return;
    [].forEach.call(document.querySelectorAll('#FacetFiltersContainer details[data-index]'), function (d) {
      if (!sokStangda[d.getAttribute('data-index')]) oppnaGrupp(d);
    });
  }
  // Kundens eget klick pa en grupprubrik: temats klickhanterare har redan
  // bytt lage (d.open) nar klicket natt hit.
  document.addEventListener('click', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('#FacetFiltersContainer details[data-index] > summary') : null;
    if (!s) return;
    var d = s.parentNode;
    var k = d.getAttribute('data-index');
    if (d.open) { delete sokStangda[k]; } else { sokStangda[k] = 1; }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sokFilterOppna);
  } else {
    sokFilterOppna();
  }
  document.addEventListener('collection:rerendered', function () { setTimeout(sokFilterOppna, 50); });
  /*
    Omgang 10 (Boozt): pa produktsidan visas fargerna som sma bilder av
    varan i respektive farg (57 x 79 px), som hos Boozt - inte som
    fargrutor. Bilden ar variantens egen bild, hamtad fran
    /products/<handle>.js. Har en farg ingen egen bild ligger fargrutan
    kvar. Temat ritar om valjaren nar kunden byter variant, darfor lyssnar
    vi efter andringar. Utseendet: assets/ns-finlir.css (ag).
  */
  var nsFargKarta = null;
  function fargbilderSatt() {
    if (!nsFargKarta) return;
    var vp = document.querySelector('main .product .product__block--variant_picker');
    if (!vp) return;
    [].forEach.call(vp.querySelectorAll('fieldset'), function (f) {
      var leg = f.querySelector('legend');
      var namn = leg ? leg.textContent.replace(/[:\s]+/g, ' ').trim().toLowerCase() : '';
      if (!nsFargKarta.namn || namn.indexOf(nsFargKarta.namn) !== 0) return;
      [].forEach.call(f.querySelectorAll('input'), function (inp) {
        var url = nsFargKarta.bilder[inp.value];
        if (!url || !inp.id) return;
        var lab = f.querySelector('label[for="' + inp.id + '"]');
        var sw = lab ? lab.querySelector('.swatch-color') : null;
        if (!sw || lab.classList.contains('ns-swimg')) return;
        lab.classList.add('ns-swimg');
        sw.style.setProperty('background-image', 'url("' + url + '")', 'important');
        sw.style.setProperty('background-color', '#f5f5f5', 'important');
        sw.style.setProperty('background-blend-mode', 'normal', 'important');
      });
    });
  }
  function fargbilder() {
    if (!document.body || !document.body.classList.contains('product-template')) return;
    var vp = document.querySelector('main .product .product__block--variant_picker');
    if (!vp || nsFargKarta || !window.fetch) return;
    nsFargKarta = { namn: '', bilder: {} };
    var sokvag = location.pathname.replace(/\/$/, '');
    fetch(sokvag + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p || !p.options || !p.variants) return;
      var idx = -1;
      p.options.forEach(function (o, i) {
        var n = (o.name || '').toLowerCase();
        if (idx < 0 && (n === 'färg' || n === 'farg' || n === 'color' || n === 'colour')) { idx = i; nsFargKarta.namn = n; }
      });
      if (idx < 0) return;
      p.variants.forEach(function (v) {
        var val = v.options ? v.options[idx] : null;
        var src = v.featured_image && v.featured_image.src;
        if (!val || !src || nsFargKarta.bilder[val]) return;
        nsFargKarta.bilder[val] = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      });
      // Bara om alla farger har en egen bild - annars blir det en
      // blandning av bilder och fargrutor.
      // Samma bild pa flera farger (varianterna har inga egna bilder) ger
      // ocksa fargrutor.
      var alla = true, unika = {};
      var varden = p.options[idx].values || [];
      varden.forEach(function (val) {
        if (!nsFargKarta.bilder[val]) alla = false; else unika[nsFargKarta.bilder[val]] = 1;
      });
      if (!alla || varden.length < 2 || Object.keys(unika).length !== varden.length) { nsFargKarta.bilder = {}; return; }
      fargbilderSatt();
      if (window.MutationObserver) {
        // Direkt i observatoren (fore nasta ritning) sa att fargrutorna
        // aldrig hinner synas mellan temats omritning och bilderna.
        new MutationObserver(fargbilderSatt).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fargbilder);
  } else {
    fargbilder();
  }
})();
